/**
 * @description
 * Don't remove even if it's unused
 * @type {unknown[]}
 */
export const EXT_MODULES: unknown[] = [];
